module.exports = __webpack_public_path__ + "img/t3-2.f64a1a02.svg";